var map = {
	"./Dark/Old/enact.svg": "./src/assets/imgs/Logos/Dark/Old/enact.svg",
	"./Dark/enact-animated.svg": "./src/assets/imgs/Logos/Dark/enact-animated.svg",
	"./Dark/enact-christmas.png": "./src/assets/imgs/Logos/Dark/enact-christmas.png",
	"./Dark/enact.png": "./src/assets/imgs/Logos/Dark/enact.png",
	"./Dark/enact.svg": "./src/assets/imgs/Logos/Dark/enact.svg",
	"./Dark/energy.svg": "./src/assets/imgs/Logos/Dark/energy.svg",
	"./Dark/envision.svg": "./src/assets/imgs/Logos/Dark/envision.svg",
	"./Dark/nwf-logo-dark.png": "./src/assets/imgs/Logos/Dark/nwf-logo-dark.png",
	"./LCPDelta-logo.svg": "./src/assets/imgs/Logos/LCPDelta-logo.svg",
	"./Light/enact-animated.svg": "./src/assets/imgs/Logos/Light/enact-animated.svg",
	"./Light/enact-christmas.png": "./src/assets/imgs/Logos/Light/enact-christmas.png",
	"./Light/enact.png": "./src/assets/imgs/Logos/Light/enact.png",
	"./Light/enact.svg": "./src/assets/imgs/Logos/Light/enact.svg",
	"./Light/energy.svg": "./src/assets/imgs/Logos/Light/energy.svg",
	"./Light/envision.svg": "./src/assets/imgs/Logos/Light/envision.svg",
	"./Light/nwf-logo-light.png": "./src/assets/imgs/Logos/Light/nwf-logo-light.png",
	"./National_Wealth_Fund_logo-alpha.png": "./src/assets/imgs/Logos/National_Wealth_Fund_logo-alpha.png",
	"./bulb-simplified.png": "./src/assets/imgs/Logos/bulb-simplified.png",
	"./bulb-simplified.svg": "./src/assets/imgs/Logos/bulb-simplified.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs/Logos sync recursive ^\\.\\/.*$";